export const TOTAL_MINUTES = [{ 
    label: 'all',
    minutes: 2540163049,
    text: null,
}, {
    label: 'breaking',
    minutes: 475089785,
    text: 'or watching the Nightly News every night for 43,357 years',
}, {
    label: 'entertainment',
    minutes: 136344318,
    text: 'or watching the Oscars 568,101 times',
}, {
    label: 'justice',
    minutes: 181492353,
    text: 'or listening to Martin Luther King’s “I Have a Dream” speech 10,676,020 times',
}, {
    label: 'politics',
    minutes: 1735243619,
    text: 'or living through 825 presidents’ four year terms',
}, {
    label: 'culture',
    minutes: 106729190,
    text: 'or flying roundtrip from New York to Tokyo 62,780 times',
}, {
    label: 'opinion',
    minutes: 156008720,
    text: 'or watching all 8 seasons of Curb Your Enthusiasm 69,646 times',
}, {
    label: 'sports',
    minutes: 106468150,
    text: 'or watching all two weeks of the Olympic games 5,281 times'
}];

let timeMap = {};
TOTAL_MINUTES.forEach((category) => {
    timeMap[category.label] = category;
});
export const CATEGORY_TIME_MAP = timeMap;



// WEBPACK FOOTER //
// ./src/utils/category-minutes.js